import React, { useState } from 'react';
import './Invite.less'
import urfuLogo from '../../img/urfu_logo_black.svg'
import scienceMinistryLogo from '../../img/science_ministry_logo.png'
import priorityLogo from '../../img/priority_logo_blue.svg'
import useAPI from '../hooks/useAPI';
import useToast from '../hooks/useToast';
import { Toast } from 'react-bootstrap';

export default function Invite(){
  const api = useAPI();
  const [showToast, setShowToast] = useState(false)

  const takePart = async () => {
    const response = await api.put('/users/innoprom')
    if(response?.status === 'success'){
      setShowToast(true)
    }
  }

  return (
    <div className='invite'>
      <div className="invite-header">
        <img className='urfu' src={urfuLogo} alt=''/>
        <img className='scienceMinistry' src={scienceMinistryLogo} alt=''/>
        <img className='priority' src={priorityLogo} alt=''/>
      </div>
      <div className='invite-main'>
        <p className='invite-description'>Панельная дискуссия «Приоритет-2030: ключевые задачи взаимодействия вузов, региона и отрасли для достижения национальных целей технологического лидерства страны».</p>
        <h1 className='invite-title'>Ключевая тема: «Технологическое партнерство: формируя образ будущего».</h1>
        <div className='invite-card inviteCard'>
          <p className='inviteCard-title'>Дата и место проведения</p>
          <p className='inviteCard-date'>08.07.2024 12:00 — 13:30</p>
          <p className='inviteCard-address'>г. Екатеринбург, Общественный центр, ул. Универсиады, д. 7</p>
          <button className='inviteCard-btn' onClick={takePart}>Участвовать</button>
        </div>
        <div className="invite-speakers inviteSpeakers">
          <div className="inviteSpeakers-title">Спикеры панельной дискуссии</div>
          <div className="inviteSpeakers-speaker">
            <p className='inviteSpeakers-speakerPost'>Модератор</p>
            <h3 className="inviteSpeakers-fio">Келлер Андрей Владимирович</h3>
            <p className="inviteSpeakers-post">и.о. директора ФГАНУ «Социоцентр»</p>
          </div>
          <div className="inviteSpeakers-grid">
            {speakers.map(speaker => <div className={'inviteSpeakers-speaker' + (speaker.fakePosition ? ' fakePosition' : '')}>
              <h3 className='inviteSpeakers-fio'>{speaker.fio}</h3>
              <p className='inviteSpeakers-post'>{speaker.post}</p>
            </div>)}
          </div>
        </div>
      </div>
      <div className="invite-footer">
        <p className="invite-copyright">© ФГАОУ ВО «УрФУ имени первого Президента России Б.Н. Ельцина» 2024</p>
      </div>
      <Toast
        style={{
          position: 'fixed', top: 4, right: 4, color: 'white', fontSize: 16, borderRadius: 6,
        }}
        className="d-inline-block m-3"
        bg="success"
        onClose={() => setShowToast(false)}
        show={showToast}
        delay={6000}
        autohide
      >
        <Toast.Body>
          Информация о вашем участии сохранена
        </Toast.Body>
      </Toast>
    </div>
  )
}

const speakers = [
  {
    fio: 'Гришкин Виталий Викторович',
    post: 'Директор Департамента координации деятельности образовательных организаций'
  },
  {
    fio: 'Кокшаров Виктор Анатольевич',
    post: 'Ректор ФГАОУ ВО «УрФУ имени первого Президента России Б.Н. Ельцина»'
  },
  {
    fio: 'Овсянников Борис Владимирович',
    post: 'Ученый секретарь ОАО «Каменск-Уральский металлургический завод»'
  },
  {
    fio: 'Саносян Андрей Григорьевич',
    post: 'Заместитель губернатора Нижегородской области'
  },
  {
    fio: 'Одоевская Елена Викторовна',
    post: 'Проректор НИУ ВШЭ',
    fakePosition: true,
  },
  {
    fio: 'Громак Денис Анатольевич',
    post: 'Вице-президент по внешним связям и взаимодействию с акционерами АО «АВТОВАЗ»'
  },
  {
    fio: 'Новоженов Денис Анатольевич',
    post: 'Технический директор ООО «ЕВРАЗ»'
  }
]
